import Layout from './layout'
export default {
  install:function (Vue) {
    Vue.component('Layout',Layout)
  }
}
